import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:rounded-md tw:text-base tw:font-medium tw:transition-all tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg:not([class*=\'size-\'])]:size-4 tw:shrink-0 tw:[&_svg]:shrink-0 tw:outline-none tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:focus-visible:ring-[3px] tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive',
  {
    variants: {
      variant: {
        'default':
          'tw:bg-primary tw:text-primary-foreground tw:shadow-xs tw:hover:bg-primary/90',
        'destructive':
          'tw:bg-destructive tw:text-white tw:shadow-xs tw:hover:bg-destructive/90 tw:focus-visible:ring-destructive/20 tw:dark:focus-visible:ring-destructive/40 tw:dark:bg-destructive/60',
        'danger':
          'tw:bg-destructive tw:text-white tw:shadow-xs tw:hover:bg-destructive/90 tw:focus-visible:ring-destructive/20 tw:dark:focus-visible:ring-destructive/40 tw:dark:bg-destructive/60',
        'outline':
          'tw:border tw:bg-background tw:shadow-xs tw:hover:bg-accent tw:hover:text-accent-foreground tw:dark:bg-input/30 tw:dark:border-input tw:dark:hover:bg-input/50',
        'secondary':
          'tw:border tw:bg-secondary tw:text-secondary-foreground tw:shadow-xs tw:hover:bg-secondary/80',
        'ghost':
          'tw:text-[#B5B5C3] tw:hover:bg-accent tw:hover:text-accent-foreground tw:dark:hover:bg-accent/50',
        'link': 'tw:text-primary tw:underline-offset-4 tw:hover:underline',
        'primary':
          'tw:bg-primary tw:text-primary-foreground tw:shadow-xs tw:hover:bg-primary/90',
        'outline-primary':
          'tw:border tw:border-primary tw:bg-background tw:text-primary tw:shadow-xs tw:hover:bg-primary tw:hover:text-primary-foreground',
        'info':
          'tw:bg-info tw:text-white tw:shadow-xs tw:hover:bg-info/90 tw:focus-visible:ring-info/20 tw:dark:focus-visible:ring-info/40',
        'outline-info':
          'tw:border tw:border-info tw:bg-background tw:text-info tw:shadow-xs tw:hover:bg-info tw:hover:text-info-foreground tw:dark:bg-input/30 tw:dark:border-input tw:dark:hover:bg-input/50',
        'light-primary':
          'tw:bg-blue-100 tw:text-primary tw:shadow-xs tw:hover:bg-primary tw:hover:text-primary-foreground',
      },
      size: {
        'default': 'tw:h-[calc(2.8rem+2px)] tw:px-4 tw:py-2 tw:has-[>svg]:px-3',
        'sm': 'tw:h-8 tw:rounded-md tw:gap-1.5 tw:px-3 tw:has-[>svg]:px-2.5',
        'lg': 'tw:h-10 tw:rounded-md tw:px-6 tw:has-[>svg]:px-4',
        'icon': 'tw:size-[calc(2.8rem+2px)]',
        'icon-xs': 'tw:size-4',
        'icon-sm': 'tw:size-8',
        'icon-lg': 'tw:size-10',
      },
    },
    defaultVariants: {
      variant: 'secondary',
      size: 'default',
    },
  },
)
